export default "__VITE_ASSET__fEBf2hXk__"